import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const volunteerSchema = itemSchema.extend({
  organization: z.literal("").or(z.string().min(1)),
  position: z.string(),
  location: z.string(),
  date: z.string(),
  startDate: z.string().optional().default(""),
  endDate: z.string().optional().default(""),
  isPresent: z.boolean().optional().default(false),
  summary: z.string(),
  url: urlSchema,
});

// Type
export type Volunteer = z.infer<typeof volunteerSchema>;

// Defaults
export const defaultVolunteer: Volunteer = {
  ...defaultItem,
  organization: "",
  position: "",
  location: "",
  date: "",
  startDate: "",
  endDate: "",
  isPresent: false,
  summary: "",
  url: defaultUrl,
};
